import { render, staticRenderFns } from "./chooseBlock.vue?vue&type=template&id=4d72dcb5&"
import script from "./chooseBlock.vue?vue&type=script&lang=js&"
export * from "./chooseBlock.vue?vue&type=script&lang=js&"
import style0 from "./chooseBlock.vue?vue&type=style&index=0&id=4d72dcb5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports